import { shallowMount } from "@vue/test-utils";
import BannerDespegarOferta from "@/components/core/custom/BannerDespegarOferta.vue";

describe("BannerDespegarOferta component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(BannerDespegarOferta);
  });

  it("Renders del component BannerDespegarOferta", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
